export default "__VITE_ASSET__CR1Eays8__"